const translations = {
  es: {
    nav: {
      services: "Servicios",
      fleet: "Flota",
      rates: "Tarifas",
      booking: "Reservar",
      contact: "Contacto",
    },
    hero: {
      overline: "Transporte Privado VIP · Ibiza",
      title: "¡Bienvenid@ a tu app de traslados en Ibiza!",
      subtitle: "¿Buscas transporte privado 24h?",
      desc: "Servicio exclusivo Mercedes Vito con sonido envolvente. Puntualidad, discreción y lujo mediterráneo.",
      cta_book: "Reservar Ahora",
      cta_quote: "Calcular Precio",
      scroll: "Desliza",
    },
    clause: {
      overline: "Filosofía IBIALCON",
      quote: "Somos un servicio privado VIP, no un taxi convencional.",
      sub: "Garantizamos puntualidad y exclusividad.",
    },
    services: {
      overline: "Nuestros Servicios",
      title: "Experiencia VIP a tu medida",
      items: [
        { title: "Traslados VIP", desc: "Aeropuerto, hotel, villa o discoteca. Chófer profesional con absoluta discreción." },
        { title: "Disponibilidad 24/7", desc: "Servicio ininterrumpido, los 365 días del año. Siempre puntuales." },
        { title: "Eventos y Villas", desc: "Logística a medida para bodas, eventos privados y tours por la isla." },
      ],
    },
    fleet: {
      overline: "Nuestra Flota",
      title: "Mercedes Vito · 8 plazas",
      features: [
        { title: "Sonido Envolvente", desc: "Sistema premium para que la fiesta empiece antes de llegar." },
        { title: "Máxima Privacidad", desc: "Cristales tintados, interior espacioso y confort absoluto." },
        { title: "Acabados de Lujo", desc: "Tapicería premium, climatización individual y Wi-Fi a bordo." },
      ],
    },
    rates: {
      overline: "Tarifas Temporada Baja",
      title: "Transparencia y exclusividad",
      desc: "Precios cerrados por zona. Sin sorpresas, sin taxímetro.",
      from: "desde",
      headers: { zone: "Zona", desc: "Descripción", price: "Tarifa desde" },
    },
    booking: {
      overline: "Reserva tu trayecto",
      title: "Formulario de Reserva",
      desc: "Selecciona tu zona, elige fecha y hora. Te confirmamos por WhatsApp al instante.",
      serviceType: {
        label: "Tipo de servicio",
        transfer: "Transfer",
        transferDesc: "Trayecto punto a punto",
        disposal: "Disposición",
        disposalDesc: "Vehículo a tu disposición por horas",
      },
      disposal: {
        blockLabel: "Bloque de horas",
        blockHint: "Elige el bloque que mejor se ajuste a tu plan",
        extraHours: "Horas extra",
        extraHint: "70€/hora (configurable)",
        before: "Antes",
        discount: "Descuento",
        total: "Total",
      },
      fields: {
        name: "Nombre completo",
        phone: "Teléfono / WhatsApp",
        email: "Email (opcional)",
        date: "Fecha",
        time: "Hora",
        origin: "Origen (ej. Aeropuerto de Ibiza)",
        destination: "Destino (ej. Ushuaïa, Hotel, Villa...)",
        zone: "Selecciona zona",
        passengers: "Pasajeros",
        notes: "Notas adicionales",
      },
      zonePicker: "Zona de destino",
      submit: "Calcular y Reservar",
      submitting: "Enviando...",
      quoteTitle: "Presupuesto",
      vehicleLine: "Mercedes Vito (8 plazas) · Servicio VIP",
      whatsappBtn: "Confirmar por WhatsApp",
      success: "¡Reserva recibida! Te contactaremos por WhatsApp.",
      error: "No se pudo enviar. Intenta por WhatsApp directamente.",
      required: "Completa los campos obligatorios.",
    },
    rincon: {
      overline: "El Rincón de IBIALCON",
      title: "Es Vedrà, el tercer punto más magnético de la Tierra",
      desc: "Pregunta a nuestro chófer por las mejores rutas para ver el atardecer. Cala d'Hort al ocaso es pura magia mediterránea.",
    },
    footer: {
      tagline: "Transfer with Quality",
      contact: "Contacto",
      whatsapp: "WhatsApp 24h",
      rights: "Todos los derechos reservados.",
      vip: "Servicio Privado VIP · Ibiza",
    },
    zoneNames: {
      "1": "Zona 1 · Cercanías Ibiza",
      "2": "Zona 2 · Aeropuerto / Playa d'en Bossa",
      "3": "Zona 3 · San Antonio / Santa Eulalia",
      "4": "Zona 4 · Norte de la isla",
    },
  },
  en: {
    nav: {
      services: "Services",
      fleet: "Fleet",
      rates: "Rates",
      booking: "Book",
      contact: "Contact",
    },
    hero: {
      overline: "Private VIP Transport · Ibiza",
      title: "Welcome to your transfer app in Ibiza!",
      subtitle: "Looking for 24h private transport?",
      desc: "Exclusive Mercedes Vito service with surround sound. Punctuality, discretion and Mediterranean luxury.",
      cta_book: "Book Now",
      cta_quote: "Get Quote",
      scroll: "Scroll",
    },
    clause: {
      overline: "IBIALCON Philosophy",
      quote: "We are a private VIP service, not a regular taxi.",
      sub: "We guarantee punctuality and exclusivity.",
    },
    services: {
      overline: "Our Services",
      title: "Tailored VIP experience",
      items: [
        { title: "VIP Transfers", desc: "Airport, hotel, villa or club. Professional chauffeur with absolute discretion." },
        { title: "24/7 Availability", desc: "Uninterrupted service, 365 days a year. Always on time." },
        { title: "Events & Villas", desc: "Bespoke logistics for weddings, private events and island tours." },
      ],
    },
    fleet: {
      overline: "Our Fleet",
      title: "Mercedes Vito · 8 seats",
      features: [
        { title: "Surround Sound", desc: "Premium audio so the party starts before you arrive." },
        { title: "Maximum Privacy", desc: "Tinted glass, roomy interior, absolute comfort." },
        { title: "Luxury Finishes", desc: "Premium upholstery, individual climate control and onboard Wi-Fi." },
      ],
    },
    rates: {
      overline: "Low Season Rates",
      title: "Transparency & exclusivity",
      desc: "Fixed prices per zone. No surprises, no meter.",
      from: "from",
      headers: { zone: "Zone", desc: "Description", price: "Rate from" },
    },
    booking: {
      overline: "Book your ride",
      title: "Booking Form",
      desc: "Pick your zone, choose date and time. We confirm via WhatsApp instantly.",
      serviceType: {
        label: "Service type",
        transfer: "Transfer",
        transferDesc: "Point-to-point ride",
        disposal: "Disposal",
        disposalDesc: "Vehicle at your disposal by hours",
      },
      disposal: {
        blockLabel: "Hour block",
        blockHint: "Pick the block that fits your plan",
        extraHours: "Extra hours",
        extraHint: "€70/hour (configurable)",
        before: "Before",
        discount: "Discount",
        total: "Total",
      },
      fields: {
        name: "Full name",
        phone: "Phone / WhatsApp",
        email: "Email (optional)",
        date: "Date",
        time: "Time",
        origin: "Pickup (e.g. Ibiza Airport)",
        destination: "Drop-off (e.g. Ushuaïa, Hotel, Villa...)",
        zone: "Select zone",
        passengers: "Passengers",
        notes: "Extra notes",
      },
      zonePicker: "Destination zone",
      submit: "Calculate & Book",
      submitting: "Sending...",
      quoteTitle: "Your Quote",
      vehicleLine: "Mercedes Vito (8 seats) · Surround Sound · VIP Service",
      whatsappBtn: "Confirm via WhatsApp",
      success: "Booking received! We'll contact you on WhatsApp.",
      error: "Could not send. Please message us directly on WhatsApp.",
      required: "Please fill in required fields.",
    },
    rincon: {
      overline: "IBIALCON's Corner",
      title: "Es Vedrà, the third most magnetic point on Earth",
      desc: "Ask our driver for the best sunset routes. Cala d'Hort at dusk is pure Mediterranean magic.",
    },
    footer: {
      tagline: "Transfer with Quality",
      contact: "Contact",
      whatsapp: "WhatsApp 24h",
      rights: "All rights reserved.",
      vip: "Private VIP Service · Ibiza",
    },
    zoneNames: {
      "1": "Zone 1 · Ibiza town area",
      "2": "Zone 2 · Airport / Playa d'en Bossa",
      "3": "Zone 3 · San Antonio / Santa Eulalia",
      "4": "Zone 4 · North of the island",
    },
  },
};

export default translations;
